const StageSeats = [
  [
    "A",
    [
      [1, false],
      [2, false],
      [3, false],
      [4, false],
      [5, false],
      [6, false],
      [7, false],
      [8, false],
      [9, false],
      [10, false],
      [11, false],
      [12, false],
      [13, false],
      [14, false],
      [15, false],
      [16, false],
      [17, false],
      [18, false],
      [19, false],
      [20, false],
      [21, false],
      [22, false],
      [23, false],
      [24, false],
    ],
  ],
  [
    "B",
    [
      [1, false],
      [2, false],
      [3, false],
      [4, false],
      [5, false],
      [6, false],
      [7, false],
      [8, false],
      [9, false],
      [10, false],
      [11, false],
      [12, false],
      [13, false],
      [14, false],
      [15, false],
      [16, false],
      [17, false],
      [18, false],
      [19, false],
      [20, false],
      [21, false],
      [22, false],
      [23, true],
    ],
  ],
  [
    "C",
    [
      [1, false],
      [2, false],
      [3, false],
      [4, false],
      [5, false],
      [6, false],
      [7, false],
      [8, false],
      [9, true],
      [10, false],
      [11, false],
      [12, false],
      [13, false],
      [14, false],
      [15, false],
      [16, false],
      [17, false],
      [18, false],
      [19, false],
      [20, false],
      [21, false],
      [22, false],
      [23, false],
      [24, false],
    ],
  ],
  [
    "D",
    [
      [1, false],
      [2, false],
      [3, false],
      [4, true],
      [5, true],
      [6, true],
      [7, false],
      [8, false],
      [9, true],
      [10, false],
      [11, false],
      [12, false],
      [13, false],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
  [
    "E",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
      [24, true],
    ],
  ],
  [
    "F",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, false],
      [7, false],
      [8, false],
      [9, false],
      [10, false],
      [11, false],
      [12, false],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
  [
    "G",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
      [24, true],
    ],
  ],
  [
    "H",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
  [
    "I",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
      [24, true],

    ],
  ],
  [
    "J",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
  [
    "K",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
      [24, true],

    ],
  ],
  [
    "L",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
  [
    "M",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
      [24, true],

    ],
  ],
  [
    "N",
    [
      [1, true],
      [2, true],
      [3, true],
      [4, true],
      [5, true],
      [6, true],
      [7, true],
      [8, true],
      [9, true],
      [10, true],
      [11, true],
      [12, true],
      [13, true],
      [14, true],
      [15, true],
      [16, true],
      [17, true],
      [18, true],
      [19, true],
      [20, true],
      [21, true],
      [22, true],
      [23, true],
    ],
  ],
];

export default StageSeats;
